import { httpCreate } from './http';

const http = httpCreate('/srv/auto-custom-comment-user');

export const autoCustomCommentUser = {
	// 自定义评论用户保存
	/**
	 *
	 * @param { String } data.nickname // 昵称
	 * @param { String } data.avatar // 头像 fileInfo格式
	 * @param { Number } params.activityId  // 直播间id
	 * @returns
	 */
	addCustomRobot(data, params) {
		return http.post('', data, { params });
	},
	/** 自定义评论用户编辑
	 *
	 * @param { Number } id // 自定义评论id
	 * @returns
	 */
	editCustomRobot(id, data) {
		return http.put(`/${id}`, data);
	},
	/** 自定义评论用户删除
	 *
	 * @param { Number } id // 自定义评论id
	 * @returns
	 */
	deleteCustomRobot(id) {
		return http.delete(`/${id}`);
	},
	/** 获取机器人列表
	 *
	 * @param { Number } activityId 直播间id
	 * @param { Number } params.page 是否分页， 0不分页。1分页
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量 0不分页。1分页
	 * @returns
	 */
	getCustomRobotList(activityId, params) {
		return http.get(`/list/${activityId}`, { params });
	},
	/** 自定义发送评论
	 *
	 * @param { Number } data.isCustom 是否自定义头像 0 否 1 是，默认1
	 * @param { Number } data.commentUserId 自定义头像id isCustom为1时必传，为0不传
	 * @returns
	 */
	addComment(data, params) {
		return http.post('/addComment', data, { params });
	},
};
